import { HorizonCategory } from "./HorizonCategory.model";
import { HorizonScanningTerm } from "./HorizonScanningTerm.model";
import { RiskType } from "./RiskType.model";
import { RiskUser } from "./RiskUser.model";

export class HorizonScanning {
  id: number;
  guid: string;
  horizonCategoryId: number;
  risk: string;
  riskTypeId: number;
  term: number;
  effectOnSociety: string;
  mitigatingActions: string;
  outlookDirection: string;
  outlookColour: string;
  previousOutlookDirection: string;
  previousOutlookColour: string;
  createdAt: Date;
  userId: number;
  trdUser: RiskUser;
  trdHorizonCategory: HorizonCategory;
  trdHorizonTerm: HorizonScanningTerm;
  trdRiskType: RiskType;
}
